import { Node } from "@tiptap/pm/model";
import { Editor, NodeViewWrapper } from "@tiptap/react";
import React, { useCallback, useRef } from "react";
import { cn } from "../../../lib/utils/index.js";

interface ImageBlockViewProps {
  editor: Editor;
  getPos: () => number;
  node: Node & {
    attrs: {
      src: string;
    };
  };
  updateAttributes: (attrs: Record<string, string>) => void;
}

export const ImageBlockView = (props: ImageBlockViewProps) => {
  const { editor, getPos, node } = props;
  const imageWrapperRef = useRef<HTMLDivElement>(null);
  const { src, caption } = node.attrs;
  const wrapperClassName = cn(
    node.attrs.align === "left" ? "ml-0" : "ml-auto",
    node.attrs.align === "right" ? "mr-0" : "mr-auto",
    node.attrs.align === "center" && "mx-auto"
  );

  const onClick = useCallback(() => {
    editor.commands.setNodeSelection(getPos());
  }, [getPos, editor.commands]);

  const onInputBlur = useCallback(
    (e) => {
      const title = e.target.value;
      editor
        .chain()
        .focus(undefined, { scrollIntoView: false })
        .setImageCaption(title)
        .run();
    },
    [editor]
  );

  return (
    <NodeViewWrapper>
      <div className={wrapperClassName} style={{ width: node.attrs.width }}>
        <div ref={imageWrapperRef}>
          <img className="block" src={src} alt="" onClick={onClick} />
          <textarea
            className="w-full h-16 mb-2 placeholder-black p-1 text-sm focus:border focus:border-gray-300 text-gray-400 border-0 rounded appearance-none"
            onBlur={onInputBlur}
            defaultValue={caption}
            onClick={onClick}
          />
        </div>
      </div>
    </NodeViewWrapper>
  );
};

export default ImageBlockView;
